import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { EmpresaProvider } from './contexts/EmpresaContext';
import PrivateRoute from './components/common/PrivateRoute';
import AppLayout from './components/layout/AppLayout';

import Login from './pages/auth/Login';
import EsqueciSenha from './pages/auth/EsqueciSenha';
import RedefinirSenha from './pages/auth/RedefinirSenha';
import Dashboard from './pages/dashboard/Dashboard';

import Empresas from './pages/empresas/Empresas';
import EmpresaForm from './pages/empresas/EmpresaForm';

import Usuarios from './pages/usuarios/Usuarios';
import UsuarioForm from './pages/usuarios/UsuarioForm';

import Unidades from './pages/unidades/Unidades';
import Qualidades from './pages/qualidades/Qualidades';
import Produtos from './pages/produtos/Produtos';
import Fornecedores from './pages/fornecedores/Fornecedores';
import Clientes from './pages/clientes/Clientes';

import Lotes from './pages/lotes/Lotes';
import LoteNovo from './pages/lotes/LoteNovo';
import LoteDetalhe from './pages/lotes/LoteDetalhe';

import Estoque from './pages/estoque/Estoque';

import Pedidos from './pages/pedidos/Pedidos';
import PedidoNovo from './pages/pedidos/PedidoNovo';
import PedidoDetalhe from './pages/pedidos/PedidoDetalhe';

import Ajustes from './pages/ajustes/Ajustes';
import AjusteNovo from './pages/ajustes/AjusteNovo';

import Relatorios from './pages/relatorios/Relatorios';

import MeuPerfil from './pages/perfil/MeuPerfil';

function Privado({ children, perfil }) {
  return (
    <PrivateRoute perfil={perfil}>
      <AppLayout>{children}</AppLayout>
    </PrivateRoute>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <EmpresaProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/esqueci-senha" element={<EsqueciSenha />} />
            <Route path="/redefinir-senha" element={<RedefinirSenha />} />

            <Route path="/dashboard" element={<Privado><Dashboard /></Privado>} />

            <Route path="/empresas" element={<Privado perfil="super_admin"><Empresas /></Privado>} />
            <Route path="/empresas/novo" element={<Privado perfil="super_admin"><EmpresaForm /></Privado>} />
            <Route path="/empresas/:id/editar" element={<Privado perfil="super_admin"><EmpresaForm /></Privado>} />

            <Route path="/usuarios" element={<Privado perfil="admin"><Usuarios /></Privado>} />
            <Route path="/usuarios/novo" element={<Privado perfil="admin"><UsuarioForm /></Privado>} />
            <Route path="/usuarios/:id/editar" element={<Privado perfil="admin"><UsuarioForm /></Privado>} />

            <Route path="/unidades" element={<Privado><Unidades /></Privado>} />
            <Route path="/qualidades" element={<Privado><Qualidades /></Privado>} />
            <Route path="/produtos" element={<Privado><Produtos /></Privado>} />
            <Route path="/fornecedores" element={<Privado><Fornecedores /></Privado>} />
            <Route path="/clientes" element={<Privado><Clientes /></Privado>} />

            <Route path="/lotes" element={<Privado><Lotes /></Privado>} />
            <Route path="/lotes/novo" element={<Privado><LoteNovo /></Privado>} />
            <Route path="/lotes/:id" element={<Privado><LoteDetalhe /></Privado>} />

            <Route path="/estoque" element={<Privado><Estoque /></Privado>} />

            <Route path="/pedidos" element={<Privado><Pedidos /></Privado>} />
            <Route path="/pedidos/novo" element={<Privado><PedidoNovo /></Privado>} />
            <Route path="/pedidos/:id" element={<Privado><PedidoDetalhe /></Privado>} />

            <Route path="/ajustes" element={<Privado><Ajustes /></Privado>} />
            <Route path="/ajustes/novo" element={<Privado><AjusteNovo /></Privado>} />

            <Route path="/relatorios" element={<Privado><Relatorios /></Privado>} />

            <Route path="/perfil" element={<Privado><MeuPerfil /></Privado>} />

            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </EmpresaProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
